export default function Header({ storeName, view, onNavigate, saving }) {
  return (
    <header className="header">
      <div className="header__inner">
        <div
          className="header__brand"
          onClick={() => onNavigate('stores')}
        >
          <span className="header__logo">🛒</span>
          <h1 className="header__title">Winkelroute</h1>
        </div>

        {storeName && (
          <nav className="header__breadcrumb">
            <span
              className="header__breadcrumb-link"
              onClick={() => onNavigate('stores')}
            >
              Winkels
            </span>
            <span className="header__breadcrumb-sep">›</span>
            <span className="header__breadcrumb-current">{storeName}</span>
            {view && view !== 'editor' && (
              <>
                <span className="header__breadcrumb-sep">›</span>
                <span className="header__breadcrumb-current">
                  {view === 'list' ? 'Boodschappenlijst' : 'Navigatie'}
                </span>
              </>
            )}
          </nav>
        )}

        <div className="header__actions">
          {saving !== undefined && (
            <span className={`header__save-indicator ${saving ? 'header__save-indicator--saving' : 'header__save-indicator--saved'}`}>
              {saving ? (
                <>
                  <span className="spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} />
                  Opslaan…
                </>
              ) : (
                <>✓ Opgeslagen</>
              )}
            </span>
          )}
        </div>
      </div>
    </header>
  )
}
